import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { CommonDispatcher } from '../../../store/common/common-dispatcher';

@Injectable({
  providedIn: 'root'
})
export class RedirectServiceService {
  constructor(
    public commonDispatcher: CommonDispatcher,
    public dialog: MatDialog,
    public router: Router,
  ) { }
  /**
   * @method showError displays the error message
   * @arg error error response from the api
   */
  public async showError(error: object): Promise<void> {
    // if (error['errorCode'] === 'UNAUTHORIZED') { //needed for local testing purposes
    if (error['errorCode'] === 'UNAUTHORIZED' || error['error']['error'] === 'invalid_client') {
      this.routeError();
    } else {
      this.commonDispatcher.setErrorCode(error['errorCode']);
      const { DialogBoxComponent } = await import('../../components/dialog-box/dialog-box.component');
      this.dialog.open(DialogBoxComponent, {
        data: {
          type: 'api-error',
          message: error['errorMessage'],
          endPoint: error['api']
        },
        width: '30em',
        height: 'auto'
      });
    }
  }
  /**
     * @function routeError route to error on unauthorized
     * @returns void
     **/
  private routeError(): void {
    this.router.navigate(['dashboard/error'], { queryParams: {}, skipLocationChange: false });
  }
}
